import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';

@Injectable({ providedIn: 'root' })
export class DocumentosElectronicosService {

  constructor(
    private api: ApiService
  ) {}

  listarDocumentos(_token: string, params: any) {
    return this.api.post<any>(
      '/transactions/electronic-documents/list',
      params
    );
  }

  listarNotasCredito(token: string, params: any) {
    return this.listarDocumentos(token, { ...params, tipo: 'nota' });
  }

  generarRide(_token: string, claveAcceso: string, estado: string) {
    return this.api.postBlob('/transactions/electronic-documents/ride', {
      claveAcceso,
      estado
    });
  }

  generarReciboInterno(
    _token: string,
    params: { idOrden?: string; numeroFactura: string; tipoFactura?: string }
  ) {
    return this.api.postBlob(
      '/transactions/electronic-documents/internal-receipt',
      params
    );
  }

  generarFacturaCliente(
    _token: string,
    params: { idOrden?: string; numeroFactura: string; tipoFactura?: string }
  ) {
    return this.api.postBlob(
      '/transactions/electronic-documents/customer-ticket',
      params
    );
  }

  exportarExcel(_token: string, params: any) {
    return this.api.postBlob(
      '/transactions/electronic-documents/excel',
      params
    );
  }

  exportarExcelNotasCredito(token: string, params: any) {
    return this.exportarExcel(token, { ...params, tipo: 'nota' });
  }

  crearNotaCredito(token: string, params: any) {
    let transactionId = Number(params?.numero);
    try {
      transactionId = Number(atob(String(params?.numero || '')));
    } catch (_) {}

    return this.api.post('/transactions/electronic-documents/credit-note/create', {
      transactionId,
      refundValue: Number(params?.valorDevolver || 0),
      reason: params?.razonModificacion || '',
      userId: params?.idUsuario,
      userName: params?.nombreUsuario || 'Sistema'
    }).pipe(
      catchError(e => {
        throw e;
      })
    );
  }

  enviarNotaCreditoSRI(claveAcceso: string, emailCliente: string, nombreCliente: string, token: string) {
    return this.api.post<{ sri: { status: string; number?: string; authorizedAt?: string } }>(
      '/transactions/electronic-documents/send-sri',
      { claveAcceso }
    ).pipe(
      map(({ sri }) => {
        const status = sri?.status || 'authorized';
        const success = status === 'authorized';
        const message = success
          ? 'Documento enviado y autorizado correctamente'
          : 'Documento enviado al SRI. Revise el estado de autorización.';

        return {
          2: message,
          7: success ? 'mail enviado' : message,
          authorizedAt: sri?.authorizedAt,
          message,
          number: sri?.number,
          status,
          success,
        };
      }),
      catchError(e => {
        throw e;
      })
    );
  }
}
